import { render, staticRenderFns } from "./Learning.vue?vue&type=template&id=a2709698&scoped=true"
import script from "./Learning.vue?vue&type=script&lang=js"
export * from "./Learning.vue?vue&type=script&lang=js"
import style0 from "./Learning.vue?vue&type=style&index=0&id=a2709698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2709698",
  null
  
)

export default component.exports